<mat-card [ngClass]="{'fix-height': configsTable.fixHeight}" class="table-container">
  <ng-container *ngIf="configsTable && data.length;else elseEmpty">
    <div>
      <table class="flex" mat-table [dataSource]="dataSource">

        <ng-container *ngFor="let config of configsTable.row;index as i" matColumnDef="{{config.columnDef}}">
          <th mat-header-cell *matHeaderCellDef>{{config.header}}</th>
          <td mat-cell *matCellDef="let element;even as even">
            <ng-container
              *ngIf="config.cell(element) || config.cell(element)===0 || config.cell(element)===false ;else emptyElement">
              <div [ngSwitch]="config.type"
                [ngClass]="{'pending':checkPending(element) , 'expiring':checkExpiring(element)}">
                <ng-container *ngSwitchCase="'price'">{{config.cell(element)|number}}</ng-container>
                <ng-container *ngSwitchCase="'date'">{{config.cell(element) |jalaliDate}}</ng-container>
                <ng-container *ngSwitchCase="'img'">
                  <img width="150px" style="margin-top: 8px;" [src]="config.cell(element)" alt="">
                </ng-container>
                <ng-container *ngSwitchCase="'icon'"><button mat-icon-button><i class="material-icons" [ngClass]="{'done' :config.cell(element),'close':
                  !config.cell(element)}">{{config.cell(element)? 'done' : 'close'}}</i></button>
                </ng-container>
                <ng-container *ngSwitchCase="'status'">
                  <div
                    [ngClass]="{'negative': (config.cell(element) === 'ناموفق') , 'positive' : (config.cell(element) === 'موفق')}">
                    {{config.cell(element) }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>{{config.cell(element)}}</ng-container>
              </div>
            </ng-container>
            <ng-template #emptyElement>
              <div [ngClass]="{'pending':element.status && element.status===3 , 'expiring':checkExpiring(element)}"> -
              </div>
            </ng-template>
          </td>
          <th mat-header-cell *matHeaderCellDef>{{config.header}}</th>
          <td mat-cell *matCellDef="let element;even as even">
            <ng-container *ngIf="config.cell(element);else emptyElement">
              <div [ngSwitch]="config.type">
                <ng-container *ngSwitchCase="'price'">{{config.cell(element)|number}}</ng-container>
                <ng-container *ngSwitchCase="'date'">{{config.cell(element) |jalaliDate}}</ng-container>
                <ng-container *ngSwitchCase="'icon'"><button mat-icon-button><i class="material-icons" [ngClass]="{'done' :config.cell(element),'close':
                  !config.cell(element)}">{{config.cell(element)? 'done' : 'close'}}</i></button>
                </ng-container>
                <ng-container *ngSwitchCase="'score'">
                  <div
                    [ngClass]="{'negative': (+config.cell(element) <= 0) , 'positive' : (+config.cell(element) >= 0)}">
                    {{config.cell(element)  +  (+config.cell(element) >= 0 ? '+':'')  }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'status'">
                  <div
                    [ngClass]="{'negative': (config.cell(element) === 'ناموفق') , 'positive' : (config.cell(element) === 'موفق')}">
                    {{config.cell(element) }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>{{config.cell(element)}}</ng-container>
              </div>
            </ng-container>
            <ng-template #emptyElement>
              -
            </ng-template>
          </td>
        </ng-container>

        <ng-container *ngIf="configsTable.operaions.length>0" matColumnDef="operation">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td class="opration" mat-cell *matCellDef="let element">
            <ng-container *ngFor="let operation of configsTable.operaions">
              <div>
                <button (click)="opetarionClickMethod(element, operation.key)"
                  *ngIf="!(operation.condition)||(operation.condition && operation.condition(element))" mat-icon-button
                  [matMenuTriggerFor]="operation.children.length>0 ?menu:''">
                  <mat-icon>{{operation.icon}}</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <ng-container *ngFor="let subOperation of operation.children">
                    <button (click)="opetarionClickMethod(element,subOperation.key)"
                      *ngIf="!(subOperation.condition)||(subOperation.condition && subOperation.condition(element))"
                      mat-menu-item>
                      <mat-icon>{{subOperation.icon}} </mat-icon>
                      {{subOperation.name}}
                    </button>

                  </ng-container>
                </mat-menu>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <div *ngIf="coutOfPage>1" class="pagination-container">
      <bt-paginator (pageSelected)="pageSelectedChange($event)" [pageNumber]="coutOfPage"></bt-paginator>
    </div>
    <footer *ngIf="configsTable.footer.length>0">
      <div *ngFor="let footer of configsTable.footer">{{footer.text}} : {{footer.sum}}</div>
    </footer>
  </ng-container>

  <ng-template #elseEmpty>
    <bt-empty></bt-empty>
  </ng-template>
</mat-card>
